import React, { useState }from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PaymentTerminal from '@components/paymentTerminalCheckDetail/indexRevamp';
import Modal from '@components/common/Modal';
import { setPaymentCheck } from '@reducers/orders';
import { setErrorPopUp } from '@reducers/notification';
import { syncCheckForPayment } from '@reducers/storeChecks';
import { flowType } from '@utility/userInfo';
import { APP_CONFIG } from '@constants';
import cross from '@assets/images/cross.svg';
import Alert from '@assets/images/Alert.png';



const PaymentTerminalCheckDeatails = (props) => {

  // State Management
  const [payLoading, setPayLoading] = useState(false)
  const [payLoadingData, setPayLoadingData] = useState('')
  const [errorpayLoading, setErrorpayLoading] = useState(false)
  const payRetryData = {data: {}, currentPage : 0};

  // Methods

  const toToStage = () => {
    setPayLoading(true)
    setPayLoadingData('Synchronizing check')
    const deviceInfo = JSON.parse(window.sessionStorage.getItem('deviceInfo'))
    const userInfo = JSON.parse(window.sessionStorage.getItem('userInfo'))
    const dataToSend = {
      deviceId: deviceInfo.deviceId,
      employeeId: Number(userInfo.id),
      storeId: deviceInfo.storeId,
      checkHeaderId: props.check.id,
      totalAmount: props.check.totalAmount,
      unpaidAmount: Number(props.check.unpaidAmount),
      paidAmount: props.check.paidAmount,
    };
    props.syncCheckForPayment(dataToSend).then((res) => {
      const syncedCheck = res;
      props.setPaymentCheck({ ...syncedCheck}).then(() => {
        props.history.replace(`${APP_CONFIG.BASE_URL}/${flowType()}/stage`);

      });
  }).catch((err) => {
    setPayLoading(false)
    props.setErrorPopUp({
      res: err.message
    })
  });
  };

  const navigateToPaymentScreen = () => {
    setPayLoading(true)
    setPayLoadingData('Synchronizing check')
    const deviceInfo = JSON.parse(window.sessionStorage.getItem('deviceInfo'))
    const userInfo = JSON.parse(window.sessionStorage.getItem('userInfo'))
    const dataToSend = {
      deviceId: deviceInfo.deviceId,
      employeeId: Number(userInfo.id),
      storeId: deviceInfo.storeId,
      checkHeaderId: props.check.id,
      totalAmount: props.check.totalAmount,
      unpaidAmount: Number(props.check.unpaidAmount),
      paidAmount: props.check.paidAmount,
    };
    props.syncCheckForPayment(dataToSend).then((res) => {
    props.setPaymentCheck({ ...props.check }).then(() => {
      props.history.replace({ pathname: `${APP_CONFIG.BASE_URL}/receipt/${props.check.id}?ticketSplitTypeId=1&splitValue=1&screenType=1` });
    });
  }).catch((err) => {
    setPayLoading(false)
    props.setErrorPopUp({
      res: err.message
    })
  });
  };

  //HTML CSS CODE

  return (
    <div className="h-100 p-3 text-white">
      
      <PaymentTerminal {...props} toToStage={toToStage} navigateToPaymentScreen={navigateToPaymentScreen} serverAppTheme={props.serverAppTheme}/>
      {<Modal
        isOpen={payLoading}
        isModalCenter
        style={{backgroundColor: '#2F2F2F'}}
      >
        <div className="col-12 px-0 py-1 justify-content-center align-items-center position-relative text-center od-text-primary text-black">
          <div
            className="fs-18 h-8 text-right px-2"
          >
            <img src={cross} style={{width:'28px',height:'28px'}} alt="cross" />
          </div>
          <div className="fs-18 text-white">{payLoadingData}</div>
          <i className='fa fa-spinner' style={{fontSize: '48px', color: 'white'}} />
        </div>
      </Modal>}
      {<Modal
        isOpen={errorpayLoading}
        isModalCenter
      >
        <div className="col-12 px-0 py-1 justify-content-center align-items-center position-relative text-center od-text-primary">
          <div
            className="fs-18 h-8 text-right px-2"
          >
            <i
              role="presentation"
              onClick={() =>{ setPayLoading(false); setErrorpayLoading(false)}}
              className="fa fa-times fs-24"
              aria-hidden="true"
            />
            <div className='text-center'>
            <h4>Error Connecting to card reader</h4>
            <img src={Alert} style={{width: '104px'}} alt="Alert" />
            <div className='col-12 row pl-5 pr-5 pt-3 pb-3'>

            <h6>Unable to connect to card reader. Please click retry to try again. You may have to restart OneDine or Reboot the tablet to connect</h6>
            </div>
            </div>
            <div className='row col-12 pb-3'>
              <div className='col-6 text-center'>
                <button className='btn text-center btn20 btn btn-primary btn-ripple od-btn-primary w-100' onClick={() =>{ setErrorpayLoading(false); payRoute(payRetryData.data, payRetryData.currentPage)}} >Retry</button>
              </div>
              <div className='col-6 text-center'>
                <button className='btn text-center btn20 btn btn-primary btn-ripple od-btn-primary w-100' onClick={() =>{ setPayLoading(false); setErrorpayLoading(false)}} >Cancel</button>
              </div>
            </div>
          </div>
          </div>
      </Modal>}
    </div>
  );
};

//Redux Part

const mapStateToProps = ({
  storeChecks, orders, oauth, theme
}) => ({
  check: orders.seats,
  loading: storeChecks.loading,
  allMenus: orders.menuItems,
  deviceInfo: oauth.deviceInformation,
  serverAppTheme: theme.serverAppTheme
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  setPaymentCheck,
  syncCheckForPayment,
  setErrorPopUp
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PaymentTerminalCheckDeatails);
